<template>
  <div id="searchCriteria">
    <ul class="head-ul">
      <li v-for="item in activeList" :key="item.id" :class="item.id===activeId?'ul-active':''"
          @click="handleSelect(item)">
        {{ item.title }}
        <img v-if="item.id===activeId" alt="" src="@/assets/images/babyFeeding/monthLine.png">
      </li>
    </ul>
    <div class="head-age">
      <p v-for="item in ageList" :key="item.id" :class="ageSeleKey.includes(item.id)?'seleActive':''"
         @click="handleAgeKey(item)">
        {{ item.name }}</p>
    </div>
    <div class="age-pops" :class="{'feedShow': feedShow}"><img alt="" src="@/assets/images/babyFeeding/zhankai.png" @click="handleClick"></div>

    <van-action-sheet v-model="feedShow">
      <div class="feed-pop">
        <h5 class="feed-h5">{{ title.replace('按', '选择') }}</h5>
        <div class="feed-content">
          <p v-for="item in ageList" :key="item.id" :class="ageSeleKey.includes(item.id)?'seleActive':''"
             @click="handleAgeKey(item)">{{ item.name }}</p>
        </div>
        <div class="feed-buttom" @click="feedShow=!feedShow">确定</div>
      </div>
    </van-action-sheet>

  </div>
</template>

<script>

export default {
  name: "searchCriteria",
  data() {
    return {
      activeId: this.tapId,
      ageSeleKey: [Number(this.$route.params.id)],
      feedShow: false,
      title: '按月龄'
    }
  },
  activated(){
    this.ageSeleKey = [Number(this.$route.params.id)]
    this.$parent.ageSeleKey = [Number(this.$route.params.id)]
    this.$emit('handleSelect', {id: 5, title: "按月龄"})
  },
  created() {
    console.log(this.ageKey, '0000===', this.$route.params.id, this.$parent.ageSeleKey);
    this.ageSeleKey = [Number(this.$route.params.id)]
    this.$parent.ageSeleKey = [Number(this.$route.params.id)]
    this.$emit('handleSelect', {id: 5, title: "按月龄"})
  },
  methods: {
    handleSelect(item) {
      this.activeId = item.id
      this.title = item.title
      this.$parent.ageSeleKey = [0]
      this.ageSeleKey = [0]
      this.$emit('handleSelect', item)
    },
    handleAgeKey(item) {
      this.ageSeleKey = [item.id]
      this.$emit('handleAgeKey', {ageSeleKey: this.ageSeleKey, item: item})
    },
    handleClick() {
      this.feedShow = !this.feedShow
    },

  },
  props: {
    activeList: {
      type: Array,
      default: () => {
        return [
          {id: 5, title: '按月龄'},
          {id: 7, title: '按营养'},
          {id: 8, title: '按功效'},
          {id: 6, title: '按病症'},
          {id: 9, title: '按季节'},
        ]
      }
    },
    ageList: {
      type: Array,
    },
    tapId: Number,
    ageKey: [Array, Number],

  }
}
</script>

<style lang="less" scoped>
#searchCriteria {
  // margin: 14px 12px;
  padding: 14px 12px;
  position: relative;

  .head-ul {
    display: flex;
    justify-content: space-between;

    li {
      font-size: 14px;
      font-weight: 500;
      color: #666666;
      position: relative;

      img {
        width: 10px;
        position: absolute;
        bottom: -2px;
        right: -10px;
      }
    }

    .ul-active {
      color: #333;
      font-weight: 600;
    }
  }

  .head-age {
    width: 314px;
    display: flex;
    justify-content: space-between;
    margin-top: 14px;
    position: relative;
    overflow-x: scroll;

    p {
      //flex: 0 0 25%;
      flex-grow: 0;
      flex-shrink: 0;
      font-weight: 500;
      color: #333333;
      font-size: 12px;
      padding: 0 8px;
      height: 30px;
      line-height: 30px;
      margin-left: 8px;

      &:first-child {
        margin-left: 0;
        margin-right: 8px;
      }


    }


    .seleActive {
      background: #FFE6F5;
      font-weight: 400;
      color: #F470BE;
      font-size: 14px;
      padding: 0 8px;
      border-radius: 15px
    }
  }

  .head-age::-webkit-scrollbar {
    width: 0;
    display: none
  }

  .age-pops {
    position: absolute;
    right: 12px;
    bottom: 21px;

    img {
      width: 14px;
    }
  }

  .feedShow{
    img {
      transform: rotateZ(180deg);
    }
  }

  ::v-deep .van-popup--round {
    border-radius: 8px 8px 0 0;
    padding-bottom: 49px;
  }

  .feed-pop {
    padding: 18px 0px 0 5px;

    .feed-h5 {
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      margin-left: 10px;
    }

    .feed-content {
      box-sizing: border-box;
      // display: flex;
      // flex-wrap: wrap;
      height: 176px;
      padding: 12px 0px 20px;

      .seleActive {
        background: #FFE6F5;
        font-weight: 400;
        color: #F470BE;
        font-size: 14px;
        //padding: 0 8px;
        border-radius: 18px
      }

      p {
        display: inline-block;
        height: 35px;
        flex-grow: 0;
        flex-shrink: 0;
        color: #333333;
        font-size: 14px;
        line-height: 34px;
        letter-spacing: 2px;
        padding: 0 8px 0 10px;
        background: rgba(102, 102, 102, .1);
        border-radius: 18px;
        margin: 0 9px 12px;
      }
    }

    .feed-buttom {
      width: 330px;
      margin: 0 auto;
      height: 44px;
      line-height: 44px;
      text-align: center;
      background: linear-gradient(98deg, #FF76C7 0%, #FF76C7 100%);
      font-size: 16px;
      font-family: PingFang-SC-Medium, PingFang-SC;
      font-weight: 500;
      color: #FFFFFF;
      border-radius: 22px;
      // border: 1px solid rgba(153, 153, 153, .5);
    }
  }

}
</style>